export default "__VITE_ASSET__BKMl_5kR__"